import { useNavigate } from 'react-router-dom'

import { CopyButton } from '@/components/CopyButton.tsx'
import { UserAvatar } from '@/components/UserAvatar.tsx'
import { Button } from '@/components/ui/button.tsx'
import { useUserContext } from '@/contexts/UserContext.tsx'
import { logout } from '@/repositories/userRepository.ts'

export const Profile = () => {
  const navigate = useNavigate()
  const { user, setUser, apiKey } = useUserContext()

  const onLogout = () => {
    logout().then(() => {
      setUser(null)
      navigate('/')
    })
  }

  return (
    <div className="flex flex-row gap-2 max-w-full pt-2 px-4">
      <div className="flex-shrink-0 flex flex-col items-center justify-center">
        <UserAvatar member={user} size="md" className="cursor-default" />
      </div>
      <div className="flex flex-col min-w-0">
        <div className="flex flex-row items-center justify-between">
          <p className="font-EN-KR-body2-regular text-contents-primary truncate">{user?.name}</p>
          <Button
            type="button"
            variant="secondary"
            onClick={onLogout}
            className="w-[57px] h-5 rounded-xs font-EN-KR-caption-bold text-contents-onDarkPrimary flex-shrink-0"
          >
            Sign out
          </Button>
        </div>
        <p className="font-EN-KR-caption-bold text-contents-secondary truncate">{`@${user?.username}`}</p>
        <p className="font-EN-KR-caption-regular text-contents-secondary truncate">{user?.email}</p>
        <div className="mt-2">
          <CopyButton
            label="API Key"
            value={apiKey}
            disabled={!apiKey}
            defaultImgSrc="/images/copy-icon.svg"
            copiedImgSrc="/images/copied-icon.svg"
          />
        </div>
      </div>
    </div>
  )
}
